import React, { Component, type JSX } from 'react';
import { CartItem } from './CartItemComponent';
import { events } from '../../util/Events';
import { cart, CART_ITEM_ADDED, CART_ITEM_REMOVED } from '../Cart/Cart';
import { Examentraining, getExamentrainingDatesLabel } from '../../models/Examentraining';
import { Article } from '../../models/Article';
import { cartItemIsArticle, cartItemIsTraining } from '../../models/type.functions';

interface CartIconProps {}

interface CartIconState {
  items: (Examentraining|Article)[];
}

/**
 * This component is displayed in the header of the website.
 * It shows the trainings and shop items in the cart.
 */
export class CartIconComponent extends Component<CartIconProps, CartIconState> {

  constructor(props: CartIconProps) {
    super(props);

    this.state = {
      items: cart.get(),
    };

    events.on(CART_ITEM_ADDED, () => this.onAddCartItem());
    events.on(CART_ITEM_REMOVED, () => this.updateCart());
  }

  /**
   * Allow mobile users to tab the icon and display the list
   */
  public onClickCartIcon(e: any): void {
    if ($(window).width() < 768) {
      e.preventDefault();
      $('.shopping-cart-icon__list').toggle();
    }
  }

  /**
   * Fetch the latest state of the cart form the service.
   */
  public updateCart(): void {
    this.setState({
      items: cart.get(),
    });
  }

  /**
   * Shortly display the cart contents.
   */
  public onAddCartItem(): void {
    this.updateCart();

    // show the cart list dropdown for a short time
    // .show() messes up the css fadeInUp animation so we use .css()
    // we use animation so are able to call a callback
    $('.shopping-cart-icon__list')
      .css('display', 'block')
      .animate({}, 0, () => {
        setTimeout(() => $('.shopping-cart-icon__list')
          .removeAttr('style'), 2400);
      });
  }

  public render(): JSX.Element {
    let cartItems = this.state.items;

    let trainings = cartItems
      .filter(item => cartItemIsTraining(item))
      .map((training: Examentraining) => (
        <CartItem key={training.id_training}
          id={training.id_training}
          title={`${training.product_type} - ${training.vak_naam} ${training.vak_niveau}`}
          subtitle={ getExamentrainingDatesLabel(training) }
          label={training.product_naam}
          price={training.prijs}
          deleteMethod={/* istanbul ignore next */(id: string): Promise<void> => cart.removeTraining(id)}
        />
      ));

    let shopItems = cartItems
      .filter(item => cartItemIsArticle(item))
      .map((article: Article) => (
        <CartItem key={article.id_item}
          id={article.id_item}
          title={`${article.title} - ${article.subject}`}
          subtitle={(article.title === 'Lyceo Samenvatting' && article.level === 'VMBO B')
            ? 'VMBO BB/KB'
            : article.level}
          label={'Geen verzendkosten'}
          price={article.price}
          deleteMethod={/* istanbul ignore next */ (id: string): Promise<void> => cart.removeShopItem(id)}
        />
      ));

    return (
      <div>
        <a href="/winkelmandje/"
          onClick={(e): void => this.onClickCartIcon(e)}
          className="shopping-cart-icon__icon">
          <span className="header-bar__item-icon header-bar__item-icon--cart">
            <i className="fa fa-shopping-cart"/>
          </span>
          {cartItems.length > 0
            && <div className="shopping-cart-icon__badge tada animated">{cartItems.length}</div>}
        </a>
        {cartItems.length > 0
            && <ul className="shopping-cart-icon__list animated fadeInUp">
              {trainings}
              {shopItems}
              <li className="shopping-cart-icon__list-item">
                <a href="/winkelmandje/"
                  className="shopping-cart-icon__to-checkout-btn btn btn-primary">
                        Naar winkelmand
                </a>
              </li>
            </ul>}
      </div>
    );
  }

}
